// via https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#safely_detecting_option_support

let supportsPassiveEvents = false;

try {
    const options = {
        get passive() {
            // This function will be called when the browser
            // attempts to access the passive property.
            supportsPassiveEvents = true;
            return false;
        }
    };
    // @ts-expect-error Check for typing
    window.addEventListener("test", null, options);
    // @ts-expect-error Check for typing
    window.removeEventListener("test" as keyof WindowEventMap, null, options as EventListenerOptions);
} catch (err) {
    supportsPassiveEvents = false;
}

export { supportsPassiveEvents };
